import React from "react";
import type { PhotoRecord } from "@kra/photo-journal-shared";
import { TAG_GROUPS } from "../lib/tagHelpers.js";
import { TagChip } from "./TagChip.js";

interface TagViewProps {
  photo: PhotoRecord;
}

export function TagView({ photo }: TagViewProps) {
  const groups = TAG_GROUPS
    .map((group) => ({
      ...group,
      values: (photo[group.key] ?? []) as string[],
    }))
    .filter((group) => group.values.length > 0);

  if (groups.length === 0) {
    return (
      <div className="rounded-[22px] border border-surface-2 bg-white/68 px-4 py-4 text-sm text-ink-2 shadow-[inset_0_0_0_1px_rgba(26,25,23,0.02)]">
        Chưa có tag cho ảnh này.
      </div>
    );
  }

  return (
    <div className="space-y-5">
      {groups.map((group) => (
        <section
          key={group.key}
          className="rounded-[22px] border border-surface-2 bg-white/72 px-4 py-4 shadow-[inset_0_0_0_1px_rgba(26,25,23,0.02)]"
        >
          <div className="mb-3 flex items-center gap-2">
            <span className="text-base">{group.emoji}</span>
            <h4 className="text-[11px] font-semibold uppercase tracking-[0.14em] text-ink-2">
              {group.label}
            </h4>
          </div>

          <div className="flex flex-wrap gap-2.5">
            {group.values.map((value) => (
              <TagChip
                key={`${group.key}-${value}`}
                label={value}
                className="bg-[#f3efe6] px-3 py-1.5 text-[11px] text-ink-1"
              />
            ))}
          </div>
        </section>
      ))}
    </div>
  );
}
